var dic = {
    bpMode: [{ id: 0, name: '包车' }, { id: 1, name: '拼车' }],
    payReceiveStatus: [{ id: 0, name: '未审核' }, { id: 1, name: '已审核' }],
    cusStatus: [{ id: 0, name: '初步洽谈' }, { id: 1, name: '重点跟进' }, { id: 2, name: '成单' }, { id: 3, name: '跟进' }, { id: 4, name: '关注状态' }, { id: 5, name: '意向客户' }],
    bool1: [{ id: 0, name: '否' }, { id: 1, name: '是' }],
    peisong: [{ id: 0, name: '待派送' }, { id: 1, name: '派送中' }, { id: 2, name: '已签收' }],//0-待派送, 1-派送中，2 已签收
    tradeType: ['进口', '出口', '内贸', '打转', '国内运输'],
    yingshouStatus: [{ id: 0, name: '待收款' }, { id: 1, name: '已收款' }, { id: 2, name: '部分收款' }, { id: 3, name: '作废' }],
    yingfuStatus: [{ id: 0, name: '待付款' }, { id: 1, name: '已付款' }, { id: 2, name: '作废' }],
    cgyf: {
        0: '成功',
        1: '失败'
    },
    laiyuan: {
        1: '平台',
        2: 'API',
        3: '其他'
    },
    getVal(key, val, att1 = "id", att2 = "name") {
        var b = "暂无";
        var arr = dic[key];
        if (arr) {
            for (let i = 0; i < arr.length; i++) {
                if (arr[i][att1] == val) {
                    b = arr[i][att2];
                    break;
                }
            }
        }

        return b;
    },
    getA(key, att = 'name') {

        var b = [];

        var arr = dic[key];
        if (arr == undefined) {
            return [];
        }

        for (let i = 0; i < arr.length; i++) {
            b.push(arr[i][att])
        }
        return b



    },

}

export default dic;


// WEBPACK FOOTER //
// ./src/util/diction.js